var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { staticClass: "input_field field_wrap", class: _vm.classWrapper },
    [
      _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
      _c("input", {
        staticClass: "font_regular font_500 text_14 mt_8",
        class: _vm.classInput,
        attrs: { type: "text", placeholder: _vm.placeholder },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "err_msg error" }, [
            _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n      ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }